import React from 'react';
import {
    Table, Tooltip, Icon, Select,
} from 'antd';
// import moment from 'moment';

const { Column } = Table;
// const dateFormat = 'YYYY-MM-DD';

// function disabledDate(current, start_date) {
//     // Can not select days after today and today
//     return current && current > moment(start_date, dateFormat);
// }

export default function CarefillLists(props) {
    const {
        refills, loading, edit_refill_id, onDispatchEdit, onDispatchSave,
        deliveryDetailsOptions, onStatusChange, status,
    } = props;

    // console.log(deliveryDate, status);

    return (
        <div style={{ marginTop: '5%' }}>
            <Table
                dataSource={refills}
                loading={loading}
                bordered
                pagination={false}
                scroll={{ x: 1250 }}
                size="middle"
                rowKey="id"
            >
                <Column
                    title="ID"
                    align="center"
                    dataIndex="id"
                    width={75}
                />
                <Column
                    title="Delivery Date"
                    align="center"
                    width={150}
                    render={
                        record => (
                            record.delivery_date
                            // Number(edit_refill_id) !== Number(record.id)
                            //     ? (
                            //         <DatePicker
                            //             format={dateFormat}
                            //             value={moment(record.delivery_date, dateFormat)}
                            //             onChange={onDeliveryDateChange}
                            //             disabled
                            //         />
                            //     )
                            //     : (
                            //         <DatePicker
                            //             format={dateFormat}
                            //             value={moment(deliveryDate, dateFormat)}
                            //             onChange={onDeliveryDateChange}
                            //             disabledDate={disabledDate}
                            //         />
                            //     )
                        )
                    }
                />
                <Column
                    title="Start Date"
                    align="center"
                    width={150}
                    dataIndex="start_date"
                />
                <Column
                    title="Name"
                    align="center"
                    width={150}
                    dataIndex="patient_name"
                />
                <Column
                    title="Address"
                    align="center"
                    width={250}
                    render={
                        record => (
                            record.address == null ? null
                                : `${record.address.line_1} ${record.address.line_2} ${record.address.city} ${record.address.pin_code} ${record.address.state}`
                        )
                    }
                />
                <Column
                    title="Location"
                    align="center"
                    width={150}
                    dataIndex="location"
                />
                <Column
                    title="Delivery Details"
                    width={200}
                    align="center"
                    render={
                        record => (
                            Number(edit_refill_id) !== Number(record.id)
                                ? (
                                    <Select
                                        showSearch
                                        style={{ width: 200 }}
                                        placeholder="Status"
                                        value={record.status}
                                        onChange={onStatusChange}
                                        disabled
                                    >
                                        { deliveryDetailsOptions }
                                    </Select>
                                )
                                : (
                                    <Select
                                        showSearch
                                        style={{ width: 200 }}
                                        placeholder="Status"
                                        value={status}
                                        optionFilterProp="children"
                                        onChange={onStatusChange}
                                        disabled={Number(edit_refill_id) !== Number(record.id)}
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    >
                                        { deliveryDetailsOptions }
                                    </Select>
                                )
                        )
                    }
                />
                <Column
                    title="Action"
                    width={75}
                    align="center"
                    render={
                        record => (
                            <span>
                                {
                                    Number(edit_refill_id) !== Number(record.id)
                                        ? (
                                            <Tooltip placement="top" title="Edit">
                                                <span>
                                                    <a onClick={() => onDispatchEdit(record)} role="button">
                                                        <Icon type="edit" />
                                                    </a>
                                                </span>
                                            </Tooltip>
                                        )
                                        : (
                                            <Tooltip placement="top" title="Save">
                                                <span>
                                                    <a onClick={() => onDispatchSave(record)} role="button">
                                                        <Icon type="save" />
                                                    </a>
                                                </span>
                                            </Tooltip>
                                        )
                                }
                            </span>
                        )}
                />
            </Table>

        </div>
    );
}



// WEBPACK FOOTER //
// ./src/component/DispatchingSystem/CarefillLists.js